import { render, staticRenderFns } from "./leftPage.vue?vue&type=template&id=e8125d02&scoped=true&"
import script from "./leftPage.vue?vue&type=script&lang=js&"
export * from "./leftPage.vue?vue&type=script&lang=js&"
import style0 from "./leftPage.vue?vue&type=style&index=0&id=e8125d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8125d02",
  null
  
)

export default component.exports